import request from '@/utils/request'

function unwrap(promise, fallbackMessage) {
  return promise.then(response => {
    const res = response.data
    if (res.code === 0) return res
    throw new Error(res.msg || fallbackMessage)
  })
}

export function listProducts(params) {
  return unwrap(request({
    url: '/travel.admin.listProducts',
    method: 'post',
    data: params
  }), '获取周边游商品列表失败')
}

export function getProduct(params) {
  return unwrap(request({
    url: '/travel.admin.getProduct',
    method: 'post',
    data: params
  }), '获取周边游商品详情失败')
}

export function saveProduct(data) {
  return unwrap(request({
    url: '/travel.admin.saveProduct',
    method: 'post',
    data
  }), '保存周边游商品失败')
}

export function updateProduct(data) {
  return unwrap(request({
    url: '/travel.admin.updateProduct',
    method: 'post',
    data
  }), '更新周边游商品失败')
}

export function publishProduct(data) {
  return unwrap(request({
    url: '/travel.admin.publishProduct',
    method: 'post',
    data
  }), '上架周边游商品失败')
}

export function offlineProduct(data) {
  return unwrap(request({
    url: '/travel.admin.offlineProduct',
    method: 'post',
    data
  }), '下架周边游商品失败')
}

export function copyProduct(data) {
  return unwrap(request({
    url: '/travel.admin.copyProduct',
    method: 'post',
    data
  }), '复制周边游商品失败')
}

export function listOrders(params) {
  return unwrap(request({
    url: '/travel.admin.listOrders',
    method: 'post',
    data: params
  }), '获取周边游订单列表失败')
}

export function getOrder(params) {
  return unwrap(request({
    url: '/travel.admin.getOrder',
    method: 'post',
    data: params
  }), '获取周边游订单详情失败')
}

export function verifyOrder(data) {
  return unwrap(request({
    url: '/travel.admin.verifyOrder',
    method: 'post',
    data
  }), '核销失败')
}

export function cancelOrder(data) {
  return unwrap(request({
    url: '/travel.admin.cancelOrder',
    method: 'post',
    data
  }), '取消订单失败')
}

export function retryRefund(data) {
  return unwrap(request({
    url: '/travel.admin.retryRefund',
    method: 'post',
    data
  }), '退款重试失败')
}

export function revealContactPhone(data) {
  return unwrap(request({
    url: '/travel.admin.revealContactPhone',
    method: 'post',
    data
  }), '查看手机号失败')
}
